export const checkComment = (comment: string) => {
  return comment.match(/^ref#(\d+)/i);
};
export const getParentVersion = (comment: string): number | undefined => {
  const match = checkComment(comment);
  return match ? parseInt(match[1], 10) : undefined;
};
